import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-select-down-icon",
  "use": "icon-select-down-icon-usage",
  "viewBox": "0 0 13 8",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 13 8\" id=\"icon-select-down-icon\">\r\n<path fill-rule=\"evenodd\" fill=\"rgb(0, 213, 255)\" d=\"M6.814,5.382 L2.266,1.093 C1.939,0.786 1.412,0.786 1.088,1.093 C0.761,1.401 0.761,1.898 1.088,2.204 L6.226,7.046 C6.388,7.199 6.601,7.275 6.816,7.275 C7.029,7.275 7.242,7.199 7.406,7.046 L7.418,7.035 L12.568,2.182 C12.894,1.874 12.894,1.377 12.568,1.072 C12.241,0.764 11.714,0.764 11.390,1.072 L6.814,5.382 Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/search/select-down-icon.svg
// module id = B91Y
// module chunks = 24